import React from 'react';
import { Box } from '@mui/material';
import { BRAND_COLORS, FONTS } from '../types/index.ts';

interface DemoBoxesBannerProps {
  className?: string;
}

// Placard "mode démo" affiché sur l'écran d'accueil tant que la base ne contient
// que les boîtes d'exemple seedées automatiquement. Habillage Load Deck : marqueur
// de voie ambre (état provisoire, ni erreur ni validation) + tampon "MODE DÉMO" en
// Saira, surface cardStock, bordure structurelle encre. Pas de bouton : le message
// disparaît de lui-même dès que l'utilisateur enregistre ses propres boîtes.
const DemoBoxesBanner: React.FC<DemoBoxesBannerProps> = ({ className }) => {
  return (
    <Box
      role="status"
      className={className}
      sx={{
        mb: 3,
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1, sm: 1.75 },
        px: { xs: 1.75, sm: 2.25 },
        py: 1.5,
        backgroundColor: BRAND_COLORS.cardStock,
        border: '1.5px solid rgba(23,34,46,0.18)',
        borderLeft: `4px solid ${BRAND_COLORS.amber}`,
        borderRadius: '4px',
      }}
    >
      {/* Tampon opérationnel — l'ancre visuelle du placard. */}
      <Box
        component="span"
        sx={{
          flexShrink: 0,
          alignSelf: { xs: 'flex-start', sm: 'center' },
          fontFamily: FONTS.display,
          fontWeight: 600,
          fontSize: 12,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: BRAND_COLORS.amberText,
          border: `1px solid ${BRAND_COLORS.amber}`,
          backgroundColor: 'rgba(224,138,22,0.08)',
          borderRadius: '3px',
          px: 0.85,
          py: 0.35,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Mode démo
      </Box>

      <Box
        component="p"
        sx={{
          m: 0,
          fontFamily: FONTS.body,
          fontSize: 14,
          lineHeight: 1.5,
          color: BRAND_COLORS.ink,
        }}
      >
        Seules des{' '}
        <Box component="span" sx={{ fontWeight: 600 }}>
          boîtes d'exemple
        </Box>{' '}
        sont présentes. Vous pouvez tester l'outil en saisissant un produit. Ce message
        disparaîtra dès que vous enregistrerez vos propres boîtes.
      </Box>
    </Box>
  );
};

export default DemoBoxesBanner;
